 <template>
    <div>
        <section class="section-top">
            <div class="row home-presentation-container">
                <div class="col-12 col-lg-6">
                    <div class="home-presentation-content">
                        <h1>Agence événementielle</h1>
                        <ul>
                            <li>Prod's Spectacle</li>
                            <li>Prod's Photos, Vidéos, Sons</li>
                            <li>Préparation Physique</li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="home-presentation-content">
                        <h1>Enseignement artistique</h1>
                        <ul>
                            <li>Break Dance</li>
                            <li>Tricking</li>
                            <li>Mixed Martial Arts</li>
                        </ul>
                        </div>
                </div>
            </div>
            <div class="row hight-word-container" @mousemove="move_video_cursor">
                <div class="col-12 col-lg-4 hight-word-text">
                    Videos
                </div>
                <div class="col-12 col-lg-4 hight-word-text">
                    Photos
                </div>
                <div class="col-12 col-lg-4 hight-word-text">
                    Sons
                </div>
            </div>
            <div class="row">
                <div class="col-12 description-home-page">
                    Origin's Prod est une <strong>agence événementielle</strong> proposant des prestations de production de spéctacles, de productions vidéos (promotionnelles, sportives, activité pro, ...), de sons et de photos. 
                    et également une <strong>école d'enseignement artistique</strong> de breakdance, tricking et arts martiaux.<br/>
                    Origin's Prod fait partie de la <a class="home-description-link" href="https://originskrew.com" target="_blank">compagnie Origin's</a>, une association de danse Hip-Hop spécialisée en Breakdance.
                </div>
            </div>
        </section>

        <CourseHome />

        <section class="section-project">
            <div class="row titre-projet-home">
                <div class="col-12 titre-projet-home-text">
                    Nos Projets
                </div>
            </div>
            <div v-if="!is_loading" class="row project-carousel-container" @mousemove="move_drag_cursor">
                <div v-if="projects && projects.length > 0" class="project-carousel-item-container" 
                    id="project-carousel-item-container" 
                    style="transform: translateX(0px);" 
                    @mousedown="init_drag_projects"
                    @mouseup="end_drag_projects"
                    @mouseleave="end_drag_projects"
                    @mousemove="drag_projects"
                    @touchstart="init_drag_projects"
                    @touchmove="drag_projects"
                    @touchcancel="end_drag_projects"
                    @touchend="end_drag_projects">
                    <div class="col-10 col-sm-8 col-md-6 col-lg-4 project-carousel-item" v-for="project in projects" :key="project.id">
                        <ProjectSummary :id="project.id" :title="project.title" :description="project.description" :mainImage="project.mainImage" @mouseup="click_on_link_project(project.id, $event);" />
                        <router-link class="home-project-link" :to="{ name: 'projet', params: { idProject: project.id } }" style="display: none;" :id="project.id"></router-link>
                    </div>
                </div>
                <div id="cursor-drag" style="top: 0; left: 0;">
                    Drag
                </div>
            </div>
            <div v-if="is_loading" class="row">
                <LoaderSpinner id="loader-spinner" />
            </div>
            <div class="row contact-button-container">
                <div class="col-10 col-sm-6 col-md-4 contact-button-col">
                    <router-link class="contact-button button-custo" to="/contacts" data-magnetic="">
                        <span class="contact-button-title">
                            <span data-text="Nous Contacter">
                                Nous Contacter
                            </span>
                        </span>
                        <span class="contact-button-ripple">
                            <span></span>
                        </span>
                    </router-link>
                </div>
            </div>
        </section>

        <PartenairesHome />
    </div>
</template>

<script>
    import ProjectSummary from '../components/ProjectSummary.vue'
    import LoaderSpinner from '../components/utils/Loader.vue'
    import PartenairesHome from '../components/PartenairesHome.vue'
    import CourseHome from '../components/CourseHome.vue'
    import axios from 'axios'

    export default {
        name: "HomeComponent",
        components: {
            ProjectSummary,
            LoaderSpinner,
            PartenairesHome,
            CourseHome
        },
        title: 'Accueil - Origin\'s Prod\'s',
        data() {

            var mousedown_in_projects_container = false;
            var initial_mouse_x_pos = 0;
            var initial_translate_value = 0;
            var translate_value = 0;
            var delta_x_max = 0;
            var delta_x_min = 0;
            var drag_in_progress = false;
            var is_loading = true;

            return {
                projects : this.getProjects(),
                mousedown_in_projects_container,
                initial_mouse_x_pos,
                initial_translate_value,
                translate_value,
                delta_x_max,
                delta_x_min,
                drag_in_progress,
                is_loading
            };
        },
        methods: {
            async getProjects() {
                let config = {
                    method: 'get',
                    url: '/api/projects/all',
                    headers: {
                        "Content-Type": "application/json"
                    }
                }

                await axios(config)
                    .then((response) => {
                        switch(response.status) {
                            case 200:
                                this.projects = response.data;
                                break;
                            case 204:
                            default:
                                this.projects = [];
                        }

                        this.is_loading = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.projects = [];

                    });
            },
            init_drag_projects: function(event){
                this.mousedown_in_projects_container = true;
                if(event.type == "touchstart"){
                     this.initial_mouse_x_pos = event.touches[0].pageX;
                }
                else {
                    this.initial_mouse_x_pos = event.pageX;
                }
                
                this.translate_value = this.initial_translate_value;

                this.delta_x_max = 0;
                this.delta_x_min = 0;

                var projects_container_element = document.getElementById("project-carousel-item-container");
                projects_container_element.style.transition = "unset";

            },
            drag_projects: function(event) {
                if(this.mousedown_in_projects_container){
                    if(event.type != "touchmove") {
                        event.preventDefault();
                    }

                    this.drag_in_progress = true;

                    var actual_mouse_x_pos = event.pageX;
                    if(event.type == "touchmove"){
                        actual_mouse_x_pos = event.touches[0].pageX;
                    }
                    
                    var delta_x_pos = actual_mouse_x_pos - this.initial_mouse_x_pos;

                    if(delta_x_pos < 0){
                        if(delta_x_pos <= this.delta_x_min){
                            this.delta_x_min = delta_x_pos;
                        }
                        else {
                            this.initial_mouse_x_pos = actual_mouse_x_pos;
                            this.initial_translate_value = this.translate_value;
                            delta_x_pos = 0;
                            this.delta_x_min = 0;
                            this.delta_x_max = 0;
                        }
                    }
                    else {
                        if(delta_x_pos >= this.delta_x_max){
                            this.delta_x_max = delta_x_pos;
                        }
                        else {
                            this.initial_mouse_x_pos = actual_mouse_x_pos;
                            this.initial_translate_value = this.translate_value;
                            delta_x_pos = 0;
                            this.delta_x_max = 0;
                            this.delta_x_min = 0;
                        }
                    }

                    this.translate_value = this.initial_translate_value + delta_x_pos;

                    var projects_container_element = document.getElementById("project-carousel-item-container");

                    projects_container_element.style.transform = "translateX(" + this.translate_value + "px)";
                }
            },
            end_drag_projects: function(event){
                this.mousedown_in_projects_container = false;
                this.drag_in_progress = false;
                
                var projects_container_element = document.getElementById("project-carousel-item-container");

                if(this.translate_value > 0){
                    projects_container_element.style.transition = "transform 0.5s";
                    projects_container_element.style.transform = "translateX(0px)";
                    this.translate_value = 0;
                    this.initial_translate_value = 0;
                }
                else {
                    var max_translate_value = (document.getElementsByClassName("project-carousel-item")[0].clientWidth * this.projects.length) - document.getElementById("project-carousel-item-container").clientWidth;
                    if(event.type == "touchend" || event.type == "touchcancel"){
                        max_translate_value = (document.getElementsByClassName("project-carousel-item")[0].clientWidth * this.projects.length) - document.getElementById("project-carousel-item-container").clientWidth;
                    }

                    max_translate_value = max_translate_value < 0 ? 0 : max_translate_value;

                    if(this.translate_value >= -max_translate_value) {
                        projects_container_element.style.transition = "unset";
                        this.initial_translate_value = this.translate_value;
                    }
                    else {
                        projects_container_element.style.transition = "transform 0.5s";
                        projects_container_element.style.transform = "translateX(-" + max_translate_value + "px)";
                        this.translate_value = -max_translate_value;
                        this.initial_translate_value = -max_translate_value;
                    }
                }
            },
            move_drag_cursor: function(event){
                var cursor_drag = document.getElementById("cursor-drag");
                
                cursor_drag.style.top = (event.pageY+5) + "px";
                cursor_drag.style.left = (event.pageX+5) + "px";
            },
            click_on_link_project: function(id, event) {
                event.preventDefault();
                if(!this.drag_in_progress) {
                    document.getElementById(id).click();
                }
            }
        }
    };
</script>

<style lang="scss">

    .section-top {
        min-height: 90vh;
    }

    .section-project {
        min-height: 100vh;
        margin-top: 2em;
    }

    .home-presentation-container {
        font-size: 1.2em;

        .home-presentation-content {
            width: fit-content;
            margin: auto;
        }

        h1 {
            font-size: 1.5em;
            padding-bottom: .3em;
        }

        ul {
            list-style: none;
            background-color: #545454;
            padding: .7em 1.5em;
            border-radius: 3px;
        }

        li {
            color: #FFF;
            font-weight: 500;
            padding-bottom: .2em;
        }
    }

    .home-annoucement-svg {
        height: 1.3em;
        width: auto;
    }

    .home-annoucement-adress {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .annoucment-home-page .home-description-link {
        font-weight: 600;
    }

    .annoucment-home-page div.text-center {
        margin-top: .5em;
    }

    .hight-word-container {
        margin-top: 3em;
        margin-bottom: 3em;
    }

    .hight-word-text {
        text-align: center;
        font-size: 6em;
        color: transparent;
        text-shadow: none;
        -webkit-text-stroke: 1px #000;
        transition: color .5s,-webkit-text-stroke .3s;
        z-index: 10;
    }

    .hight-word-text:hover {
        color: #000;
        -webkit-text-stroke: 1px transparent;
        cursor: pointer;
    }

    .description-home-page {
        font-size: 1.2em;
        text-align: justify;
    }

    .home-description-link {
        text-decoration: none;
        color: inherit;
    }

    .home-description-link:hover {
        color: lightgray;
        text-decoration: none;
    }

    .titre-projet-home {
        min-height: 25vh;
        align-items: center;
    }

    .titre-projet-home-text {
        font-size: 3.5em;
    }

    .project-carousel-container {
        min-height: 50vh;
        margin-bottom: 2em;
    }

    #cursor-drag {
        visibility: hidden;
        width: 3em;
        height: 3em;
        position: absolute;
        text-align: center;
        align-items: center;
        color: #fff;
        background: #000;
        border-radius: 50%;
        font-size: 1em;
        line-height: 3em;
        transition: top 0.1s, left 0.1s;
        will-change: top, left;
    }

    .project-carousel-container:hover {
        cursor: pointer;
    }

    .project-carousel-container:hover #cursor-drag {
        visibility: visible;
    }

    .project-carousel-item-container {
        display: flex;
        white-space: nowrap;
        user-select: none;
    }

    .project-carousel-item {
        padding: 1em 1em 0 1em;
        display: inline-block;
        flex-shrink: 0;
        white-space: normal;
    }

    .home-project-link {
        color: inherit;
        text-decoration: none;
        width: 100%;
    }

    .home-project-link:hover {
        color: inherit;
        text-decoration: none;
    }

    .contact-button-container {
        min-height: 25vh;
    }

    .contact-button-col {
        margin-right: auto;
        margin-left: auto;
        line-height: 25vh;
    }

    .button-custo {
        position: relative;
        margin: 0;
        color: inherit;
        background: 0 0;
        border: 0;
        outline: 0 !important;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        letter-spacing: inherit;
        line-height: inherit;
        text-align: inherit;
        text-transform: inherit;
        text-indent: inherit;
        text-decoration: none;
    }

    .contact-button {
        height: 4em;
        padding: 0;
        min-width: 100%;
        border-radius: 60px;
        display: inline-flex;
        -moz-box-align: center;
        align-items: center;
    }

    .contact-button::after {
        content: "";
        position: absolute;
        top: 1px;
        left: 1px;
        right: 1px;
        bottom: 1px;
        border: 1px rgba(0,0,0,.1) solid;
        border-radius: inherit;
        transition: border-color .2s;
        
    }

    .contact-button[data-magnetic]::before {
        content: "";
        display: block;
        position: absolute;
        top: -2em;
        left: -2em;
        right: -2em;
        bottom: -2em;
    }

    .contact-button-title {
        position: relative;
        top: -1px;
        display: block;
        overflow: hidden;
        z-index: 2;
        margin-left: auto;
        margin-right: auto;
    }

    .contact-button-title span {
        display: block;
        font-size: 1.1em;
        font-weight: 600;
        text-align: center;
        transform-origin: left top;
        transition: color .2s,transform .4s,
            -webkit-transform .4s,
            -moz-transform .4s,
            -o-transform .4s;
    }

    .contact-button-title span::after {
        content: attr(data-text);
        display: block;
        position: absolute;
        top: 150%;
        left: 0;
        transform: skewY(5deg);
        transform-origin: left top;
        transition: transform .4s,
            -webkit-transform .4s,
            -moz-transform .4s,
            -o-transform .4s;
    }

    .contact-button-ripple {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        overflow: hidden;
        transform: translateZ(0);
        border-radius: inherit;
    }

    .contact-button-ripple span {
        display: block;
        width: 100%;
        height: 100%;
        transform: translateY(100%);
        background: #000;
        border-radius: 50%;
        transition: transform .5s cubic-bezier(.4,0,0,1),border-radius .5s cubic-bezier(.4,0,0,1),
            -webkit-transform .5s cubic-bezier(.4,0,0,1),
            -moz-transform .5s cubic-bezier(.4,0,0,1),
            -o-transform .5s cubic-bezier(.4,0,0,1),
            -webkit-border-radius .5s cubic-bezier(.4,0,0,1),
            -moz-border-radius .5s cubic-bezier(.4,0,0,1);
    }

    .contact-button:hover {
        text-decoration: none;

        .contact-button-title span {
            color: #fff;
            transform: translateY(-150%) skewY(-7deg);
        }

        .contact-button-title span::after {
            transform: skewY(7deg);
        }

        .contact-button-ripple span {
            border-radius: 0;
            transform: translateY(0);
            transition-duration: 0s,0s;
            animation: cb-checkbox_rounded-ripple-in .5s cubic-bezier(.4,0,0,1);
        }
    }

    #loader-spinner {
        margin-bottom: 3em;
        margin-top: 2em;
        height: 3em;
    }
    
    @keyframes cb-checkbox_rounded-ripple-in {
        0% {
            -webkit-border-radius: 100%;
            border-radius: 100%;
            -webkit-transform: translateY(-100%) translateZ(0);
            transform: translateY(-100%) translateZ(0);
        }

        100% {
            -webkit-border-radius: 0;
            border-radius: 0;
            -webkit-transform: translateY(0) translateZ(0);
            transform: translateY(0) translateZ(0);
        }
    }

    @media (max-width: 1290px) {
        .hight-word-text {
            font-size: 5em;
        }
    }

    @media (max-width: 1085px) {
        .hight-word-text {
            font-size: 4em;
        }
    }

    @media (max-width: 992px) {
        .hight-word-text {
            font-size: 6em;
        }
    }

    @media (max-width: 576px) {
        .hight-word-container {
            margin-top: 3em;
        }

        .section-top, 
        .project-carousel-container, 
        .contact-button-container, 
        .section-project {
            min-height: 0;
        }

        .titre-projet-home {
            min-height: 0;
            margin-bottom: 2em;
            margin-top: 2em;
        }

        .contact-button-col {
            line-height: 10vh;
        }

        .project-carousel-container:hover #cursor-drag {
            visibility: hidden;
        }
    }

</style>